import clsx from 'clsx'
import type {ReactNode} from 'react'

interface UserAvatarProps {
    userName: null | string
    fallbackContent?: ReactNode
    small?: boolean
    className?: string
    fallbackContentClassName?: string
    forceFallbackContent?: boolean
}

// Аватар пользователя.
export function UserAvatar(props: UserAvatarProps) {

    const {
        userName,
        fallbackContent,
        small,
        className,
        fallbackContentClassName,
        forceFallbackContent,
    } = props

    let content: ReactNode = '?'
    if (userName && userName.length > 0 && !forceFallbackContent) {
        content = userName.substring(0, 2)
    } else if (fallbackContent) {
        content = fallbackContent
    }

    return (
        <div
            className={clsx(
                'profile-avatar',
                small ? 'profile-avatar-sm' : null,
                className,
                userName && !forceFallbackContent ? null : fallbackContentClassName
            )}
        >
            {content}
        </div>
    )
}
